import { CommentEditCancelButton } from './CommentEditCancelButton';
import { CommentEditSaveButton } from './CommentEditSaveButton';

export const CommentEditActions = {
  SaveButton: CommentEditSaveButton,
  CancelButton: CommentEditCancelButton,
};
